import React, { EventHandler, useEffect } from "react"
import UserList from "./UserList";
import { responseHero } from "../../utils/axiosInterceptor";
import { System } from "../../models/system.model";

const options = [
    { id: 1, name: 'name', label: 'név' },
    { id: 2, name: 'email', label: 'email' },
    { id: 3, name: 'phone', label: 'telefonszám' }
]

export default function SearchBar () {
    const [searchText, setSearchText] = React.useState<string>('')
    const [searchOption, setSearchOption] = React.useState<string>("name")

    const [systems, setSystems] = React.useState<System[]>([]);
    const [selectedSystem, setSelectedSystem] = React.useState<number>(0);

    useEffect(() => {
        const getSys = async () => {
            await responseHero.get(`${process.env.REACT_APP_API_URL}/systems`).then((response) => {
                setSystems([{ id: 0, name: 'összes' }, ...response.data]);
            }).catch(error => {
                console.error(error.response.data);
            })
        }

        getSys();
    }, [])
    

    return (
        <>
        <div className="m-10">
        <div className="flex items-center mt-2">
                <ul className="w-full items-center text-sm font-medium rounded-lg sm:flex bg-dark-blue">
                <label className="ml-2 text-white">Kereső: </label>
                <input
                    className="ml-2 px-2 py-1 border border-white-300 rounded text-dark-blue focus:outline-none"
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
                    {options.map((option, index) => (
                    <li
                        key={option.id}
                        className={`${
                        index !== options.length - 1 ? 'mr-2 border-b sm:border-b-0 sm:border-r border-white' : ''
                        }`}
                    >
                        <div className="flex items-center pl-3">
                        <input
                            id={option.name}
                            value={option.name}
                            checked={searchOption === option.name}
                            onChange={(e) => setSearchOption(e.target.value)}
                            type="radio"
                            className="focus:outline-none w-4 h-4 text-cream"
                        />
                        <label
                            htmlFor={option.name}
                            className="py-3 ml-2 mr-2 text-sm font-medium text-cream"
                        >
                            {option.label}
                        </label>
                        </div>
                    </li>
                    ))}
                </ul>
            </div>

            {/*
            <div className="flex items-center mt-2">
                <ul className="w-full items-center text-sm font-medium rounded-lg sm:flex bg-dark-blue">
                <label htmlFor="search" className="ml-2 text-white">Projekt: </label>
                    {systems.map((system, index) => (
                    <li
                        key={system.id}
                        className={`${
                        index !== systems.length - 1 ? 'mr-2 border-b sm:border-b-0 sm:border-r border-white' : ''
                        }`}
                    >
                        <div className="flex items-center pl-3">
                        <input
                            value={system.id}
                            checked={selectedSystem === system.id}
                            onChange={(e) => setSelectedSystem(parseInt(e.target.value, 10))}
                            type="radio"
                            className="focus:outline-none w-4 h-4 text-cream"
                        />
                        <label
                            htmlFor={system.name}
                            className="py-3 ml-2 mr-2 text-sm font-medium text-cream"
                        >
                            {system.name}
                        </label>
                        </div>
                    </li>
                    ))}
                </ul>
            </div>
            */}


            </div>
            <UserList searchText={searchText} searchOption={searchOption} selectedProject={selectedSystem}/>
        </>
    )
}
